module.exports = __webpack_public_path__ + "static/media/image_Ellipse_bLACK.98db8496.svg";